import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollReveal from "@/components/ScrollReveal";

const AGB = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <section className="pt-32 pb-20 bg-gradient-hero">
        <div className="container mx-auto px-4">
          <ScrollReveal>
            <h1 className="text-5xl md:text-7xl font-bold text-foreground mt-4 mb-6">
              AGB
            </h1>
          </ScrollReveal>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4 max-w-3xl">
          <ScrollReveal>
            <div className="prose prose-invert max-w-none space-y-8 text-foreground/85 font-light leading-relaxed">
              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 1 Geltungsbereich</h2>
                <p>
                  Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen 4FaceMedia, Karl Leich Straße 7a, 44805 Bochum (nachfolgend „Auftragnehmer") und dem jeweiligen Auftraggeber (nachfolgend „Kunde") über die Erbringung von Kreativ- und Medialeistungen.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 2 Vertragsgegenstand</h2>
                <p>
                  Der Auftragnehmer erbringt Leistungen in den Bereichen Corporate Identity, Webseiten-Erstellung, Medienproduktion und Social Media Marketing. Art und Umfang der Leistungen ergeben sich aus dem jeweiligen Angebot bzw. der Auftragsbestätigung.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 3 Angebot und Vertragsschluss</h2>
                <p>
                  Angebote des Auftragnehmers sind freibleibend. Ein Vertrag kommt erst durch die schriftliche Auftragsbestätigung des Auftragnehmers oder durch den Beginn der Leistungserbringung zustande.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 4 Vergütung und Zahlungsbedingungen</h2>
                <p>
                  Die Vergütung richtet sich nach dem vereinbarten Angebot. Rechnungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zu begleichen. Bei Zahlungsverzug ist der Auftragnehmer berechtigt, Verzugszinsen in gesetzlicher Höhe zu berechnen.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 5 Mitwirkungspflichten des Kunden</h2>
                <p>
                  Der Kunde stellt dem Auftragnehmer alle für die Durchführung des Auftrags erforderlichen Unterlagen, Informationen und Materialien rechtzeitig und kostenfrei zur Verfügung. Verzögerungen, die auf fehlende Mitwirkung zurückzuführen sind, gehen zu Lasten des Kunden.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 6 Nutzungsrechte</h2>
                <p>
                  Mit vollständiger Bezahlung der vereinbarten Vergütung gehen die Nutzungsrechte an den erstellten Werken auf den Kunden über, sofern nichts anderes vereinbart wurde. Vor vollständiger Bezahlung verbleiben sämtliche Rechte beim Auftragnehmer.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 7 Haftung</h2>
                <p>
                  Der Auftragnehmer haftet nur für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten beruhen. Die Haftung ist auf die Höhe der vereinbarten Vergütung beschränkt.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">§ 8 Schlussbestimmungen</h2>
                <p>
                  Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist Bochum, sofern der Kunde Kaufmann ist. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AGB;
